module.exports = __webpack_public_path__ + "img/RORBPJS40071.d5ccdc99.png";